const Footer = () => {
  return (
    <footer className="py-8 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mt-8 text-center text-neutral-400 text-sm">
          &copy; {new Date().getFullYear()}-2025 Octant, all rights reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;